
import React from 'react';
import './TableAnswersForType3.scss';
import { openInputFormsForAnswersType3, openDeleteInputFormsForAnswers  } from '../../../../adminSlice';

const TableAnswersForType3 = (props) => {

const { dispatch } = props;
const onEdit = (e) => {
    

    const id = e.target.value;
    console.log(id);
    dispatch(openInputFormsForAnswersType3(id));

}
const onDelete = (e) => {
   

    const id = e.target.value;
   // console.log(id);
    dispatch(openDeleteInputFormsForAnswers(id));

}

const   renderTable = () => {
    let  data =  props.data;
    return (
        data.map(item => {
           // console.log(item.id + " " + item.label);
            return(
                
                    <div key={item.answer_id}>
                        
                        <div className='box-row'>
                            <p className='small-font'>id {item.answer_id}</p>
                            <div className='box'>
                                <button  className='bigbtn' value={item.answer_id}>{item.content}</button>
                            </div>
                        
                        <p className='small-font'>{item.answer_right ? 'да' : 'нет'}</p>
                        <div className='edit'>
                         <button className='smallbtnEdit'  value={item.answer_id} onClick={onEdit} ></button>
                         <button className='smallbtnDelete' value={item.answer_id} onClick={onDelete} ></button>
                        </div>
                         </div>
                    </div>
                    
                

                )
            })
        )    
   }
   


        return(
            <div className="TableAnswersForType3">
                
                <div>
                    
                    {renderTable()}
                    
                   
                    
                    

                </div>
                
            </div>
        )
    
}
export default TableAnswersForType3;